module.exports = __webpack_public_path__ + "static/img/home_func1.2273dcea.png";